<template>
  <div class="__card__order-return mt-3">
    <h1 class="__card__order-return_title">Khách thanh toán</h1>

     <!-- <div v-if="!refundPolicy" class="row w-100 d-flex justify-content-center my-2">
        <div class="col-10">
          <b-alert class="custom-alert m-0" show variant="warning text-dark">
            Giá trị cần hoàn trả bằng 0 do cửa hàng đã bật cấu hình <b>“Không hoàn tiền khi đổi trả hàng”</b>.<br />
            Để cài đặt lại, vui lòng đi tới
            <b><router-link :to="{ path: '/setting/config' }">Cấu hình bán hàng</router-link></b>
          </b-alert>
        </div>
      </div> -->

    <BottomPrice></BottomPrice>
    <el-form label-width="180px" class="w-100 mt-3">
      <el-form-item label="Khách phải trả">
        <b>{{ formatMoneyNotUnit(returnAmount) }} đ</b>
      </el-form-item>
      <el-form-item label="Khách thanh toán">
        <div class="d-flex">
          <el-select v-model="payMethod" style="width: 260px">
            <el-option v-for="item in payMethodList" :key="item.id" :label="item.text" :value="item.value"> </el-option>
          </el-select>
          <InputMoneyVmodel
            style="width: 260px"
            v-model="returnMoney"
            :max="returnAmount - getPricePayed"
            class="form-control ml-4"
          ></InputMoneyVmodel>
          <el-input class="ml-4" style="width: 260px" v-model="referenceCode" placeholder="Nhập mã tham chiếu" />
          <el-button type="danger" v-if="mposPayStatus == 'PROCESS'" class="ml-4" @click="cancelMpos">Hủy</el-button>
          <el-button v-else :disabled="getPricePayed == returnAmount || returnMoney == 0" class="ml-4" @click="addOutComeAmount"
            >Thêm</el-button
          >
        </div>
      </el-form-item>
      <b-alert variant="warning text-dark" class="mb-4 custom-alert" :show="mposPayStatus == 'PROCESS'">
        <div class="mb-2">
          <b style="font-size: 16px;"><img class="mr-2" src="@/assets/images/Payment_Mpos.png"  />Hướng dẫn thanh toán</b>
        </div>
        <div>Nhập mã <b>“POS01”</b> trên ứng dụng MPOS để thanh toán số tiền này.</div>
      </b-alert>

      <b-alert
        variant="warning text-dark"
        class="mb-4 custom-alert"
        :show="mposPayStatus == 'CANCEL' && dismissCountDown"
        dismissible
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="(event) => (dismissCountDown = event)"
      >
        <div class="mb-2">
          <b style="font-size: 16px;"><img src="@/assets/images/Payment_Mpos.png" />Yêu cầu thanh toán đã quá hạn</b>
        </div>
        <div>Hệ thống đã tự động huỷ yêu cầu thanh toán này. Vui lòng bấm <b>Thêm</b> để thực hiện lại.</div>
      </b-alert>
    </el-form>
    <b-table tbody-tr-class="repay-table" :items="rePay" :fields="fieldsRePay" :key="updateUI" show-empty>
      <template #empty>
        <EmptyTable content="Chưa có thanh toán nào" noImage></EmptyTable>
      </template>
      <template #cell(requestAt)="data">
        {{ data.item.params.requestAt | formatDateTime }}
      </template>
      <template #cell(payMethod)="data">
        {{ allPayment[data.item.params.payMethod].name || data.item.params.payMethod }}
      </template>
      <template #cell(amount)="data">
        {{ formatMoneyNotUnit(data.item.params.amount) }}
      </template>
      <template #cell(gatewayTransactionId)="data">
        {{ data.item.params.gatewayTransactionId }}
      </template>
      <template #cell(edit)="data">
        <span v-if="!getIsPayWithMpos" @click="deleteItem(data.index)"
          ><img class="delete-icon" src="@/assets/images/delete-vector.png"
        /></span>
      </template>
    </b-table>

    <div class="mt-3 w-100">
      <PayDetail>
        <template #title>Tổng tiền hàng trả</template>
        <template #price>{{ formatMoneyNotUnit(getReturnPrice) }} đ</template>
      </PayDetail>
      <PayDetail>
        <template #title>Tổng tiền hàng đổi</template>
        <template #price>{{ formatMoneyNotUnit(getExchangePrice) }} đ</template>
      </PayDetail>
      <div class="bottom-border w-50 ml-auto"></div>
      <PayDetail>
        <template #title>Khách phải trả</template>
        <template #price
          ><b>{{ formatMoneyNotUnit(returnAmount) }} đ</b></template
        >
      </PayDetail>
      <PayDetail>
        <template #title>Đã thanh toán</template>
        <template #price>{{ formatMoneyNotUnit(getPricePayed) }} đ</template>
      </PayDetail>
      <div class="bottom-border w-50 ml-auto"></div>
      <PayDetail>
        <template #title>Còn lại</template>
        <template #price
          ><b>{{ formatMoneyNotUnit(returnAmount - getPricePayed) }} đ</b></template
        >
      </PayDetail>
    </div>
    <div class="box-loading" v-if="loading">
      <div class="loading">
        <i class="bx bx-loader-circle bx-spin bx-rotate-90 fz50"></i>
      </div>
    </div>
  </div>
</template>

<script>
import BottomPrice from "./bottomPrice.vue";
import InputMoneyVmodel from "./inputMoneyVmodel.vue";
import PayDetail from "./payDetail.vue";
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import { allPayment } from "@/utils/mapping";
import { OrdersService } from "@/services/nextshop/orders.service";
import Swal from "sweetalert2";

export default {
  components: { PayDetail, BottomPrice, InputMoneyVmodel },
  props: {
    updateOrderId: {
      type: String,
      default: "",
    },
    createOrderData: {
      type: Object,
    },
    dataItem: {
      type: Object,
    },
    rePay: {
      type: Array,
    },
    // refundPolicy: {
    //   type: Boolean
    // }
  },
  data() {
    return {
      loading: false,
      allPayment: allPayment,
      test: "",
      updateUI: 1,
      dismissCountDown: 0,
      mposPayStatus: "",
      payMethod: "CASH_NEXT_SHOP",
      payMethodList: [
        {
          id: 1,
          text: "Tiền mặt",
          value: "CASH_NEXT_SHOP",
        },
        {
          id: 2,
          text: "Chuyển khoản",
          value: "BANK_TRANSFER_NEXT_SHOP",
        },
        {
          id: 3,
          text: "MPOS",
          value: "SWIPE_MPOS",
        },
        {
          id: 4,
          text: "Quẹt thẻ POS khác",
          value: "SWIPE_OTHER",
        },
      ],

      fieldsRePay: [
        {
          key: "requestAt",
          label: "Thời gian",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "payMethod",
          label: "Phương thức",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "amount",
          label: "Số tiền hoàn",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "gatewayTransactionId",
          label: "Mã tham chiếu",
          thStyle: { width: "20%", "min-width": "120px" },
        },
        {
          key: "edit",
          label: "",
          thStyle: { width: "5%", "min-width": "50px" },
        },
      ],

      returnMoney: 0,
      referenceCode: "",
      id: "",
      listOutcomesIdPayed: [],
    };
  },
  created() {
    this.setIsPayWithMpos(false);
    this.setIsPaying(false);
  },
  methods: {
    ...mapMutations("ordersReturn", ["setIsPayWithMpos", "setIsPaying"]),
    async addOutComeAmount() {
      if (this.getIsPayWithMpos) {
        // thường
        if (this.payMethod != "SWIPE_MPOS") {
          // this.pushRepay();
          const params = {
            orderId: this.updateOrderId,
            paymentList: [
              {
                amount: this.returnMoney * 1000,
                isNew: true,
                paymentGateway: this.allPayment[this.payMethod].paymentGateway,
                paymentMethod: this.allPayment[this.payMethod].paymentMethod,
                status: "SUCCESS",
                gatewayTransactionId: this.referenceCode,
              },
            ],
          };
          // console.log(params)
          // return
          try {
            this.loading = true;
            const response = await OrdersService.updateExchangeReturnOrder(params);
            if (response.success) {
              this.pushRepay();
              Swal.fire({
                icon: "success",
                title: '<a style="color:#3e69f6; font-size:20px; font-family:BeVietnam">Thành công</<a>',
                html: '<span style="color:#9093A4; font-size: 14px;" >Hoàn tiền cho khách thành công</span>',
                confirmButtonText: "Xác nhận",
              });
            }
          } catch (error) {
            console(error);
          } finally {
            this.loading = false;
          }
        }

        // mpos
        if (this.payMethod == "SWIPE_MPOS") {
          this.mposPayStatus = "PROCESS";
          // chặn tạo đơn khi đã tạo đơn thành công
          this.setIsPaying(true);
          this.startCheck();
          return;
        }
      } else {
        // thường
        if (this.payMethod != "SWIPE_MPOS") {
          this.pushRepay();
        }

        // mpos
        if (this.payMethod == "SWIPE_MPOS") {
          this.mposPayStatus = "PROCESS";
          // chặn tạo đơn khi đã tạo đơn thành công
          if (!this.getIsPayWithMpos) {
            // create
            this.$emit("createOrder");
          }
          this.setIsPayWithMpos(true);
          this.setIsPaying(true);
          this.startCheck();
          return;
        }
      }
    },
    async checkMposPay() {
      try {
        const id = this.getSoOrderId();
        // console.log(id)
        // return
        if (id) {
          const response = await OrdersService.getOrderById(id);
          if (response.success) {
            console.log("check", response);
            const payList = response.data.outcomes.filter(
              (e) => e.params && e.params.status == "SUCCESS" && e.params.payGateway == "MPOS"
            );
            // return
            if (payList.length > 0) {
              if (payList.length > 1) {
                const result = payList.find((e) => !this.listOutcomesIdPayed.includes(e.outcomeId));
                if (result) {
                  this.listOutcomesIdPayed.push(result.outcomeId);
                  this.clearCheck();
                  this.mposPayStatus = "";
                  this.setIsPaying(false);
                  this.pushRepay();
                  return;
                }
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getSoOrderId() {
      const result = this.createOrderData.furtherInstructions.find(
        (e) => e.params && e.key == "RETURN_ORDER" && e.params.exchangeOrderId
      );
      if (result) {
        return result.params.exchangeOrderId;
      } else return null;
    },
    pushRepay() {
      let item = {
        params: {
          requestAt: moment(),
          payMethod: this.payMethod,
          amount: this.returnMoney,
          isNew: true,
          gatewayTransactionId: this.referenceCode,
        },
      };
      // this.rePay.push(item);
      // this.$emit("updateRePay", this.rePay);
      this.$emit("addRepayItem", item)
      this.referenceCode = ""
    },
    cancelMpos() {
      this.mposPayStatus = "";
      this.setIsPaying(false);
      this.clearCheck();
    },
    clearCheck() {
      clearInterval(this.id);
    },
    startCheck() {
      this.id = setInterval(() => {
        console.log("check running");
        if (this.updateOrderId) {
          this.checkMposPay();
        }
      }, 3000);
    },

    deleteItem(index) {
      this.$emit("deleteRepayItem", index)
      // this.$emit("updateRePay", this.rePay);
    },
    getReturnMoneyAfterPay() {
      return this.returnAmount - this.getPricePayed;
    },
  },
  destroyed() {
    this.clearCheck();
  },
  computed: {
    ...mapGetters("ordersReturn", ["getReturnPrice", "getExchangePrice", "getIsPayWithMpos"]),
    returnAmount() {
      return this.getExchangePrice - this.getReturnPrice;
    },
    getPricePayed() {
      let total = 0;
      this.rePay.forEach((e) => {
        total += e.params.amount;
      });
      return total;
    },
    getPriceWillPay() {
      return this.returnAmount - this.getPricePayed;
    },
  },
  watch: {
    getPricePayed: {
      handler() {
        this.returnMoney = this.getReturnMoneyAfterPay()
        // console.log(this.returnMoney);
      },
      immediate: true,
    },
    getPriceWillPay() {
      this.returnMoney = this.getReturnMoneyAfterPay()
    }
  },
};
</script>

<style lang="scss" scoped>
.custom-alert {
  padding: 16px;
  border-color: #ffc043;
  background-color: #fff9ec;
  margin: auto;
  img {
    width: 24px;
  }
}
</style>
